"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const hooks_1 = require("./hooks");
const react_2 = require("@osmosys/react");
const inputs_1 = require("../../../inputs");
exports.SelectSampleContentFeed = () => {
    const { contentMappingDraft: draft, cmsId, } = hooks_1.useContentMappingDetailContext();
    return (react_1.default.createElement("div", { className: "flex-full-row-centered" },
        react_1.default.createElement("div", { style: { maxWidth: 400 }, className: "flex-full-col-centered" },
            react_1.default.createElement(react_2.OsmosysDiv, { osysName: "SelectSampleContentFeed.inner" },
                react_1.default.createElement("div", { className: "text-center" },
                    react_1.default.createElement(react_2.OsmosysIcon, { osysIcon: "contentFeed", size: "3x", className: "mb-3" }),
                    react_1.default.createElement("p", { className: "lead" }, "Select a sample content feed to begin mapping")),
                react_1.default.createElement(inputs_1.OsmosysResourceSelectBox, { resource: "contentFeed", cmsId: cmsId, onChange: sampleContentFeed => {
                        draft.setState({
                            sampleContentFeed,
                        });
                    } })))));
};
//# sourceMappingURL=SelectSampleContentFeed.js.map